export const OPEN_EDIT_NOTIFICATION_DATE = "OPEN_EDIT_NOTIFICATION_DATE";
export const CLOSE_EDIT_NOTIFICATION_DATE = "CLOSE_EDIT_NOTIFICATION_DATE";

export const UPDATE_NOTIFICATION_DATE_REQUEST = "UPDATE_NOTIFICATION_DATE_REQUEST";
export const UPDATE_NOTIFICATION_DATE_REQUEST_SUCCESS = "UPDATE_NOTIFICATION_DATE_REQUEST_SUCCESS";
export const UPDATE_NOTIFICATION_DATE_REQUEST_ERROR = "UPDATE_NOTIFICATION_DATE_REQUEST_ERROR";

export const CHANGE_NOTIFICATION_DUE_DATE = 'CHANGE_NOTIFICATION_DUE_DATE';

export const updateNotificationDate = (siteInspectionId, date) => {
    return {
        type: 'CALL_API',
        types: [UPDATE_NOTIFICATION_DATE_REQUEST, UPDATE_NOTIFICATION_DATE_REQUEST_SUCCESS, UPDATE_NOTIFICATION_DATE_REQUEST_ERROR],
        path: `api/siteinspection/${siteInspectionId}/notificationDate`,
        method: 'put',
        payload: { date }
    };
}

export const openNotificationDateDialog = (siteInspectionId, date) => {
    return {type: OPEN_EDIT_NOTIFICATION_DATE, payload: {siteInspectionId, date}}
}

export const closeNotificationDateDialog = () => {
    return {type: CLOSE_EDIT_NOTIFICATION_DATE}
}

export const changeNotificationDueDate = (date) => {
    return {type: CHANGE_NOTIFICATION_DUE_DATE, payload: {date}}
}


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/notification.js